<template>
  <div>
    <div class="uiBreadcrumb">
      <ul class="uiClrfix" v-if="lang == 'chs'">
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />首页</a>
        </li>
        <li><span>/</span><a class="cur">联系我们</a></li>
      </ul>
      <ul class="uiClrfix" v-else>
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />Home</a>
        </li>
        <li><span>/</span><a class="cur">Contact Us </a></li>
      </ul>
    </div>
    <div class="center">
      <div class="about_main" v-if="lang == 'chs'">
        <h3 class="about_main_title">{{ mianText.title }}</h3>
        <div v-for="(item,i) in textList" :key="i">
          <!-- <h4 style="margin-bottom: 12px">{{ item.name }}</h4> -->
          <div style="margin-bottom: 12px"> <span class="main-left">地址：</span>{{ item.address }}</div>
          <div style="margin-bottom: 12px" v-if="item.tel"><span class="main-left">电话：</span>{{ item.tel }}</div>
          <div style="margin-bottom: 12px" v-if="item.fax"><span class="main-left">传真：</span>{{ item.fax }}</div>
          <div style="margin-bottom: 32px" v-if="item.email"><span class="main-left">邮箱：</span>{{ item.email }}</div>
        </div>
      </div>
      <div class="about_main" v-else>
        <h3 class="about_main_title">{{ mianText.titleE }}</h3>
        <div v-for="(item,i) in textList" :key="i">
          <!-- <h4 style="margin-bottom: 12px">{{ item.nameE }}</h4> -->
          <div style="margin-bottom: 12px"><span class="main-left">Address：</span>{{ item.addressE }}</div>
          <div style="margin-bottom: 12px" v-if="item.tel"><span class="main-left">Tel：</span>{{ item.tel }}</div>
          <div style="margin-bottom: 12px" v-if="item.fax"><span class="main-left">Fax：</span>{{ item.fax }}</div>
          <div style="margin-bottom: 32px" v-if="item.email"><span class="main-left">Email：</span>{{ item.emailE }}</div>
        </div>
      </div>
      <div class="icon_box hidden">
        <a
          href="https://www.facebook.com/share.php?&u=https%3A%2F%2Fwww.waterwood.hk%2Fa-list%2F6895-eng%3Flang%3Dchs&t=%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC-%E6%B0%B4%E6%9C%A8%E6%8A%95%E8%B3%87%E7%AE%A1%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8" target=“_blank”
        >
          <svg-icon class="facebook icon" icon-class="facebookfacebook52" />
        </a>
        <a
          href="https://service.weibo.com/share/share.php?url=https%3A%2F%2Fwww.waterwood.hk%2Fa-list%2F6895-eng%3Flang%3Dchs&title=%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC-%E6%B0%B4%E6%9C%A8%E6%8A%95%E8%B3%87%E7%AE%A1%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&searchPic=false#_loginLayer_1685510547008" target=“_blank”
        >
          <svg-icon class="weibo icon" icon-class="weibo" />
        </a>
        <span @click="toShowWeixin()">
          <svg-icon class="weixin icon" icon-class="weixin" />
        </span>
        <span @click="toShowApp()">
          <svg-icon class="dianhua icon" icon-class="dianhua" />
        </span>
        <svg-icon
          class="dayin icon"
          icon-class="piaojudayinji"
          v-print="print"
        />
        <div class="icon_text" v-if="lang == 'chs'">分享给朋友</div>
        <div class="icon_text" v-else>Share to friends</div>
        <div class="icon_text text_right" v-if="lang == 'chs'">打印</div>
        <div class="icon_text text_right" v-else>Print</div>
        <div class="weixin_dialog" v-if="weixinShow">
          <div class="dialog_close" @click="closeWeixin()"></div>
          <div v-if="lang == 'chs'">
            <div class="dialog_title">分享至微信好友和朋友圈</div>
            <img src="../assets/images/usC.png" alt="" />
            <div class="dialog_text">用微信扫描二维码</div>
            <div class="dialog_text">分享至微信好友和朋友圈</div>
          </div>
          <div v-else>
            <div class="dialog_title">Share to Friends or post on Moments</div>
            <img src="../assets/images/usE.png" alt="" />
            <div class="dialog_text">Open WeChat app and scan the QR code</div>
            <div class="dialog_text">Share - WeChat</div>
          </div>
        </div>
        <div class="app_dialog" v-if="AppShow">
          <div class="dialog_close" @click="closeApp()"></div>
          <div v-if="lang == 'chs'">
            <div class="dialog_title">转发至WhatsApp</div>
            <div class="dialog_text">
              <div class="setp">第一步</div>
              <div class="content">
                点击打开以下网址
                <a href="http://web.whatsapp.com">
                  <span>http://web.whatsapp.com</span>
                </a>
              </div>
            </div>
            <div class="dialog_text">
              <div class="setp">第二步</div>
              <div class="content">以WhatsApp手机客户端扫描登入网页版</div>
            </div>
            <div class="dialog_text">
              <div class="setp">第三步</div>
              <div class="content">
                拷贝本活动网址于WhatsApp网页版对话框发送
              </div>
            </div>
          </div>
          <div v-else>
            <div class="dialog_title">Share to WhatsApp</div>
            <div class="dialog_text">
              <div class="setp">Setp 1</div>
              <div class="content">
                Click to open the following website:
                <a href="http://web.whatsapp.com">
                  <span>http://web.whatsapp.com</span>
                </a>
              </div>
            </div>
            <div class="dialog_text">
              <div class="setp">Setp 2</div>
              <div class="content">Sign in the web version of WhatsApp</div>
            </div>
            <div class="dialog_text">
              <div class="setp">Setp 3</div>
              <div class="content">
                Copy the URL of this event and send it in the WhatsApp webpage
                dialog box
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContactUs",
  data() {
    return {
      lang: "",
      mianText: {
        title: "联系我们",
        titleE: "Contact Us",
      },
      textList: [
        {
          address: "香港湾仔港湾道26号华润大厦3406A室",
          addressE:
            "Suite 3406A, China Resources Building, 26 Harbour Road, Wanchai, Hong Kong",
          tel: "(852) 3468-5400",
          fax: "(852) 3186-2882​",
          email: "info@waterwood.one",
          emailE: "info@waterwood.one",
        },
        // {
        //   name: "北京办事处:",
        //   nameE: "BJ Office：",
        //   address: "地址：中国北京市朝阳区曙光西里甲5号院21号楼凤凰置地广场F座1201室",
        //   addressE:
        //     "Address：Suite 1201, Building 21, Shu Guang Xi Li Jia 5 Hao Yuan, Chaoyang District, Beijing 100028 P.R.C.",
        //   tel: "(86)10-6280-0331",
        //   fax: "(86)10-6280-0187",
        //   email: "info@waterwood.hk",
        // },
        // {
        //   name: "上海办事处:",
        //   nameE: "SH Office: ",
        //   address: "地址：中国上海市徐汇区桂林路406号华鑫中心1号楼1126室",
        //   addressE:
        //     "Address：Suite 1126, Building 1, Huaxin Center, 406 Guilin Road, Xuhui District, Shanghai 200233 P.R.C.",
        //   tel: "",
        //   fax: "",
        //   email: "info@waterwood.hk",
        // },
      ],
      weixinShow: false,
      AppShow: false,
      print: {
        id: "printBill",
        popTitle: "联系我们-水木投資管理有限公司", // 打印配置页上方的标题
        previewTitle: "联系我们-水木投資管理有限公司", // 打印预览的标题
        zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        standard: "",
        extarCss: "",
      },
    };
  },
  methods: {
    //展示微信弹窗
    toShowWeixin() {
      this.weixinShow = true;
    },
    //关闭微信弹窗
    closeWeixin() {
      this.weixinShow = false;
    },
    //展示whatsapp弹窗
    toShowApp() {
      this.AppShow = true;
    },
    //展示whatsapp弹窗
    closeApp() {
      this.AppShow = false;
    },
  },
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
    } else {
      this.lang = "chs";
    }
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>
@media print {
  .hidden {
    display: none;
  }
}
.uiBreadcrumb {
  width: 1200px;
  padding: 0 15px;
  margin: 15px auto;
  height: 19px;
}

.uiBreadcrumb ul li {
  float: left;
}

.uiBreadcrumb ul li:nth-child(1):hover a {
  color: #233a78;
}

.uiBreadcrumb ul li span {
  padding: 0 5px;
}

.uiBreadcrumb ul li a {
  color: #999;
  font-size: 14px;
}

.uiBreadcrumb ul li .cur {
  color: #333;
  font-size: 14px;
}
.center {
  width: 1200px;
  margin: auto;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.about_main {
  margin-top: 30px;
  min-height: 260px;
  line-height: 27px;
  padding: 60px 210px 90px;
  font-size: 16px;
}
.main-left{
  display: inline-block;
  width: 90px;
}
.about_main_title {
  padding: 20px 0 30px;
}
.icon_box {
  position: relative;
  padding: 20px 230px 100px;
  font-size: 36px;
  color: #ccc;
}
.icon {
  margin: 0 5px;
  cursor: pointer;
  color: #ccc;
}

.facebook:hover {
  color: #2F4D9F;
}
.weibo:hover {
  color: #f00;
}
.weixin:hover {
  color: #95ec69;
}
.dianhua:hover {
  color: #19c9ac;
}
.dayin {
  float: right;
}
.dayin:hover {
  color: #666;
}
.icon_text {
  font-size: 16px;
}
.text_right {
  float: right;
  width: 46px;
  text-align: center;
  margin-top: -24px;
}
.weixin_dialog {
  position: absolute;
  bottom: 180px;
  left: 320px;
  width: 210px;
  min-height: 280px;
  padding: 30px;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.app_dialog {
  position: absolute;
  bottom: 180px;
  left: 350px;
  width: 280px;
  min-height: 120px;
  padding: 30px;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.dialog_title {
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: #000;
}
.dialog_text {
  font-size: 12px;
  line-height: 22px;
  color: #666;
}
.dialog_text a {
  color: #4099FF;
}
.setp {
  float: left;
  width: 60px;
  font-weight: bold;
}
.content {
  float: left;
  width: 220px;
}

.dialog_close {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 14px;
  height: 14px;
  background-image: url("../assets/images/close.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
}
</style>